module.exports = __webpack_public_path__ + "static/media/factoryPurple.4cb50398.svg";